// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#modal .create-request-component{margin-top:0}#modal .create-request-component .subtitle{color:#7b8794}#modal .create-request-component .txt{margin-top:20px;color:#51606d}#modal .create-request-component .buttons{margin-top:60px}#modal .create-request-component .radio-tab-container{width:50%}\n", ""]);
// Exports
module.exports = exports;
